<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入名称"
            v-model="queryInfo.query"
            clearable
            @clear="getShopList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getShopList"
            ></el-button>
          </el-input>
        </el-col>
        <!-- -->
        <!-- <el-col :span="6" v-if="canLook == 1">
          <el-button type="primary" size="mini" @click="addDialogVisible = true">添加经销商</el-button>
          <el-button type="primary" size="mini" @click="mutableSetSalesman">批量修改业务员</el-button>
        </el-col> -->
        <!-- <el-col :span="2" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col> -->
      </el-row>

      <!-- 用户列表区域 -->
      <el-table
        :data="userlist"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column fixed type="selection" width="55"> </el-table-column> -->
        <!-- <el-table-column type="index"></el-table-column> -->

        <el-table-column label="id" prop="id" width="50px"></el-table-column>

        <el-table-column
          align="center"
          label="头像"
          width="120px"
          :show-overflow-tooltip="true"
          prop="avatar"
        >
          <template slot-scope="scope">
            <el-popover placement="right" title="" trigger="click">
              <el-image
                slot="reference"
                :src="scope.row.avatar"
                :alt="scope.row.avatar"
                style="max-height: 200px; max-width: 200px"
              ></el-image>
              <el-image
                style="max-height: 500px; max-width: 500px"
                :src="scope.row.avatar"
              ></el-image>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column label="姓名" width="120px">
          <template slot-scope="scope">
            <div>{{ scope.row.nickname }}</div>
          </template>
        </el-table-column>


        <el-table-column
          label="邀请人"
          prop="c_id"
          width="90px"
        ></el-table-column>

        <el-table-column
          label="上级"
          prop="p_id"
          width="70px"
        ></el-table-column>

        <el-table-column
          label="收藏"
          prop="collect_ids"
          width="60px"
        ></el-table-column>
 
        <el-table-column
          label="下载ids"
          prop="download_ids"
          width="130px"
        ></el-table-column>

        <el-table-column
          label="光亮值"
          prop="gl_count"
          width="80px"
        ></el-table-column>

        
        <el-table-column
          label="注册时间"
          prop="create_time"
          width="110px"
        ></el-table-column>
        <el-table-column
          label="备注"
          prop="beizhu"
          width="150px"
        ></el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-star-off"
              size="mini"
              @click="clickSetVip(scope.row.id,scope.row.gl_count)"
              >修改光亮值</el-button
            >
            
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 拒绝的对话框 -->
    <el-dialog
      title="修改光亮值"
      :visible.sync="setDialogVisible"
      width="50%"
      @close="setGLDialogVisibleClosed"
    >
      <el-form
        :model="editForm"  
        label-width="130px"
      >
        <el-form-item label="当前光亮值" prop="price">
          <el-input v-model="gl_count" disabled></el-input>
        </el-form-item>

        <el-form-item label="新光亮值" prop="price">
          <el-input v-model="new_gl_count"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="vipBeizhu">
          <el-input v-model="gl_beizhu"></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="setDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserGlCount">确定</el-button>
      </span>
    </el-dialog>

    <!-- 下架的对话框 -->
    <!-- <el-dialog
      title="填写下架理由"
      :visible.sync="xiajiaDialogVisible"
      width="50%"
    >
      <el-input v-model="statusTxt" placeholder="请输入下架理由"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xiajiaDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postxiajia">下架</el-button>
      </span>
    </el-dialog> -->

   
  </div>
</template>

<script>
// import vipTypeList from '../system/gradeList.vue';

export default {
  data() {
    return {
      dateValue: "",
      setId: 0,
      setDialogVisible: false,

      statusTxt: "",
      xiajiaId: 0,
      xiajiaDialogVisible: false,

      canLook: 1,
      exportUrl:
        "https://hsapi.hsxsn.cn/exportUserList?mPhone=" +
        localStorage.getItem("phone"),
      // 获取店铺列表的参数对象
      queryInfo: {
        query: "",
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },

      vipTypeList: [],
      userlist: [],
      gl_count: '',
      new_gl_count: '',
      gl_beizhu: '',
    
      total: 0,
      
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,

      // 查询到的用户信息对象
      editForm: {
        id: "",
        name: "",
        phone: "",
        s_name: "",
        school: "",
        grade: "",
        jifenCount: "",
        studyLevel: true,
        beizhu: null,
      },

      // 修改表单的验证规则对象
      editFormRules: {
        name: [{ required: true, message: "请输入家长姓名", trigger: "blur" }],
        s_name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },

      multipleSelection: [],
      multipleSelectionjson: null,
    };
  },

  created() {
    this.getShopList();
    // this.getUserRoleList()
    // this.getSalemansList()
  },

  methods: {
    // 多选选择的项
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach((element) => {
        this.multipleSelection.push({ id: element.id });
      });
      if (this.multipleSelection) {
        this.multipleSelectionjson = JSON.stringify(this.multipleSelection);
        this.exportUrl =
          "https://hsapi.hsxsn.cn/exportUserList?data=" +
          this.multipleSelectionjson +
          "&mPhone=" +
          localStorage.getItem("phone");
      } else {
        this.multipleSelectionjson = null;
        // this.exportUrl = "javascript:return false;"
        this.exportUrl =
          "https://hsapi.hsxsn.cn/exportUserList?mPhone=" +
          localStorage.getItem("phone");
      }
    },

    async getShopList() {
      if (window.sessionStorage.getItem("pathCanLook") == 2) {
        //仅查看
        this.canLook = 2;
      }
      const { data: res } = await this.$http.get("admin/user/getAllUsers", {
        params: this.queryInfo,
      });
      if (res.code !== 200) {
        return this.$message.error("暂无用户！");
      }

      console.log(res);
      this.userlist = res.result.list.data;
      this.total = res.result.count;
    },

    async getUserRoleList() {
      const { data: res } = await this.$http.get("admin/user/getUserType");
      if (res.code !== 200) {
        return this.$message.error("暂无角色列表！");
      }
      this.rolesList = res.result;
      console.log(res);
    },

   

    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log(newSize);
      this.queryInfo.pagesize = newSize;
      this.getShopList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.queryInfo.pagenum = newPage;
      this.getShopList();
    },

    // 监听 switch 开关状态的改变
    async agreen(id) {
      console.log(id);
      const { data: res } = await this.$http.post("/admin/shop/updateStatus", {
        status: 1,
        id: id,
      });
      if (res.code !== 200) {
        return this.$message.error("审核通过失败！");
      }
      this.$message.success("审核已成功！");
      this.getShopList();
    },

    // 展示设置vip对话框
    async clickSetVip(id,gl_count) { 
      this.gl_count = gl_count;
      this.setId = id;
      this.setDialogVisible = true;
    },


    // 定义格式化封装函数
    formaData(timer) {
      const year = timer.getFullYear();
      const month = timer.getMonth() + 1; // 由于月份从0开始，因此需加1
      const day = timer.getDate();
      const hour = timer.getHours();
      const minute = timer.getMinutes();
      const second = timer.getSeconds();
      return `${this.pad(year, 4)}-${this.pad(month)}-${this.pad(day)}`;
    },
    // 定义具体处理标准
    // timeEl 传递过来具体的数值：年月日时分秒
    // total 字符串总长度 默认值为2
    // str 补充元素 默认值为"0"
    pad(timeEl, total = 2, str = "0") {
      return timeEl.toString().padStart(total, str);
    },

    // 展示拒绝的对话框
    async showXiajiaDialog(id) {
      this.xiajiaId = id;
      this.xiajiaDialogVisible = true;
    },

    //上架
    shangjia(id) {
      var that = this;
      this.$confirm("此操作将上架该店铺, 是否继续?", "提示", {
        confirmButtonText: "上架",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.postShangjia(id);
        })
        .catch(() => {});
    },

    // 上架
    //商店营业状态 shopStatus
    // 0后台审核通过/重新上架店铺，已上架，用户显示，
    // 1后台下架店铺，用户不显示店铺。
    // 2商家手动打烊，用户显示店铺为打烊，第二天需要点击开店(变为0)才开始，这个优先级比设置的开店时间高
    async postShangjia(id) {
      const { data: res } = await this.$http.post(
        "/admin/shop/updateShopStatus",
        {
          shopStatus: 0,
          id: id,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("上架失败！");
      }
      this.$message.success("已上架！");
      this.getShopList();
    },

    async postxiajia(id) {
      if (!this.statusTxt) {
        return this.$message.error("输入下架理由");
      }

      const { data: res } = await this.$http.post(
        "/admin/shop/updateShopStatus",
        {
          shopStatus: 1,
          id: this.xiajiaId,
          statusTxt: this.statusTxt,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("下架失败！");
      }
      this.$message.success("已下架！");
      this.statusTxt = null;
      this.xiajiaDialogVisible = false;
      this.getShopList();
    },

    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },

    changeSalemanDialogClosed() {
      this.$refs.changeSalemanFormRef.resetFields();
    },

    setGLDialogVisibleClosed() {
      this.$refs.czFormRef.resetFields();
    },

    // 编辑按钮点击
    async editUserGlCount(userId) {
      const { data: res } = await this.$http.post("/admin/user/editUserGlCount", {
        params: {
          id: userId,
          gl_count: this.new_gl_count,
        },
      });
      console.log(res);
      if (res.code != 200) {
        return this.$message.error("获取信息失败");
      }
      this.setDialogVisible = true;
    },

    // 监听修改用户对话框的关闭事件
    setGLDialogVisibleClosed() {
      this.$refs.czFormRef.resetFields();
    },

    // 修改用户信息并提交
    editUserInfo() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          "admin/users/updateUserInfo",
          this.editForm
        );
        if (res.code !== 200) {
          return this.$message.error("更新用户信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getShopList();
        // 提示修改成功
        this.$message.success("更新用户信息成功！");
      });
    },
    // // 根据Id删除对应的用户信息
    // async removeUserById(phone) {
    //   // 弹框询问用户是否删除数据
    //   const confirmResult = await this.$confirm(
    //     "此操作将永久删除该用户, 是否继续?",
    //     "提示",
    //     {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     }
    //   ).catch((err) => err);
    //   if (confirmResult !== "confirm") {
    //     return this.$message.info("已取消删除");
    //   }
    //   const { data: res } = await this.$http.post("admin/users/delete", {
    //     phone: phone,
    //   });
    //   if (res.code !== 200) {
    //     return this.$message.error("删除用户失败！");
    //   }
    //   this.$message.success("删除用户成功！");
    //   this.getShopList();
    // },
  },
};
</script>

<style lang="less" scoped>
.aaaa {
  margin-left: 10px;
}

.el-image {
  width: 49% !important;
  height: 49% !important;
}
.demonstration {
  color: red;
  font-size: 30px;
}
</style>
